import React, { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
	className?: string;
	children: ReactNode;
}

export const BoxAuthCard: React.FC<Props> = ({ className, children }) => {
	return (
		<div
			className={clsx(
				'md:bg-white shadow-shadow2 w-full lg:border lg:border-gray-disabled lg:rounded-2xl py-11 lg:py-12 px-4 lg:px-8 lg:w-[600px]',
				className
			)}
		>
			{children}
		</div>
	);
};
